import React, { useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import Box from '@material-ui/core/Box';
import { makeStyles } from "@material-ui/core/styles";

import TicketsManagerTabs from "../../components/TicketsManagerTabs/";
import Ticket from "../../components/Ticket/";
import TicketAdvancedLayout from "../../components/TicketAdvancedLayout";

import { TicketsContext } from "../../context/Tickets/TicketsContext";

import { QueueSelectedProvider } from "../../context/QueuesSelected/QueuesSelectedContext";

const useStyles = makeStyles((theme) => ({
    page: {
        flex: 1,
        minHeight: 0,
        height: "100%",
        padding: theme.spacing(1.5),
        boxSizing: "border-box",
        background: theme.palette.pageBackground || "#f8fafc",
    },
}));

const TicketAdvanced = (props) => {
    const classes = useStyles();
    const { ticketId } = useParams();
    const { setCurrentTicket } = useContext(TicketsContext)

    useEffect(() => {
        return () => {
            setCurrentTicket({ id: null, code: null })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const renderMessageContext = () => {
        if (ticketId && ticketId !== "undefined") {
            return <Ticket />
        }
        return renderTicketsManagerTabs()
    }

    const renderTicketsManagerTabs = () => {
        return <TicketsManagerTabs
        />
    }

    return (
        <QueueSelectedProvider>
            <Box className={classes.page}>
                <TicketAdvancedLayout>
                    <Box height="100%" minHeight={0} display="flex" flexDirection="column" overflow="hidden">
                        {renderMessageContext()}
                    </Box>
                </TicketAdvancedLayout>
            </Box>
        </QueueSelectedProvider>
    );
};

export default TicketAdvanced;
